import React from 'react';
import { HeaderContainer, HeaderWrapper, HeaderLogo } from './Header.styles';

export const Header: React.FC = () => (
  <HeaderContainer>
    <HeaderWrapper>
      <HeaderLogo />
    </HeaderWrapper>
  </HeaderContainer>
);
